import Tricks, { ITrick } from '@Config/tricks';

import Mass from '@FreeRider/Physics/Mass';

/*-------------------- Events ----------------------*/
import EventEmitter from '@Utils/Events/EventEmitter';
import EventChannels from '@Config/event_channels';


class Trick
{
    private wheelie: number;
    private endo: number;
    private jump: number;
    private rotation: number;
    private angleOld: number;
    private swap: Boolean;

    /**
     * Constructor
     */
    constructor()
    {
        this.reset();
    }

    /**
     * Resets tricks
     */
    public reset()
    {
        this.wheelie = 0;
        this.endo = 0;
        this.jump = 0;
        this.rotation = 0;
        this.angleOld = 0;
        this.swap = false;
    }

    /**
     * Updates and calculates tricks
     * @param frontMass
     * @param rearMass
     * @param dir
     */
    public update(frontMass: Mass, rearMass: Mass, dir: number)
    {
        let wheelie = this.wheelie;
        let endo = this.endo;
        let jump = this.jump;
        let swap = this.swap;
        let angleOld = this.angleOld;
        let rotation = this.rotation;

        const tricks: ITrick[] = [];

        jump++;

        /*-------------------- Wheelie -----------------------*/

        if (rearMass.contact && frontMass.contact === false)
        {
            wheelie++;

            if (wheelie > 10)
            {
                tricks.push(Tricks.WHEELIE);

                wheelie = 0;
            }
        }
        else
        {
            wheelie = 0;
        }

        /*--------------------- Endo -----------------------*/

        if (frontMass.contact && rearMass.contact === false)
        {
            endo++;

            if (endo > 10)
            {
                tricks.push(Tricks.ENDO);

                endo = 0;
            }
        }
        else
        {
            endo = 0;
        }

        /*--------------------- Flips  -----------------------*/

        const frontMassPosition = frontMass.position;
        const rearMassPosition = rearMass.position;

        const ppX = frontMassPosition.x - rearMassPosition.x;
        const ppY = frontMassPosition.y - rearMassPosition.y;

        let angle = Math.atan2(ppY, ppX);

        angle = (angle / (Math.PI * 2) - Math.floor(angle / (Math.PI * 2))) * Math.PI * 2;

        let dif = angle - angleOld;

        if (dif > Math.PI) { dif = -Math.PI * 2 + dif; }
        if (dif < -Math.PI) { dif = Math.PI * 2 + dif; }

        rotation += dif;
        angleOld = angle;

        if (frontMass.contact || rearMass.contact)
        {
            const rotations = ((rotation * dir) / 3.8) | 0;

            if (rotations < 0)
            {
                switch (rotations)
                {
                    case -1:
                        tricks.push(Tricks.BACKFLIP);
                        break;
                    case -2:
                        tricks.push(Tricks.DOUBLE_BACKFLIP);
                        break;
                    case -3:
                        tricks.push(Tricks.TRIPPLE_BACKFLIP);
                        break;
                    case -4:
                        tricks.push(Tricks.QUADRUPLE_BACKFLIP);
                        break;
                }
            }
            else if (rotations > 0)
            {
                switch (rotations)
                {
                    case 2:
                        tricks.push(Tricks.FRONTFLIP);
                        break;
                    case 3:
                        tricks.push(Tricks.DOUBLE_FRONTFLIP);
                        break;
                    case 4:
                        tricks.push(Tricks.TRIPPLE_FRONTFLIP);
                        break;
                    case 5:
                        tricks.push(Tricks.QUADRUPLE_FRONTFLIP);
                        break;
                }
            }

            rotation = 0;
        }

        /*------------ Big Air / Perfect Landing  ------------*/

        if (frontMass.contact || rearMass.contact || swap)
        {
            if (jump > 50)
            {
                tricks.push(Tricks.BIG_AIR);
            }

            if (frontMass.contact && rearMass.contact)
            {
                if (jump > 25)
                {
                    tricks.push(Tricks.PERFECT_LANDING);
                }
            }

            jump = 0;
        }

        if (tricks.length > 0)
        {
            EventEmitter.emit(EventChannels.PLAYER, 'trick', tricks)
        }

        swap = false;

        this.wheelie = wheelie;
        this.endo = endo;
        this.jump = jump;
        this.swap = swap;
        this.angleOld = angleOld;
        this.rotation = rotation;
    }

}

export default Trick;